

class AppRoutes {
    static LOGIN = "/login";
    static SEARCH_SPACES = "/search_spaces";

    static SPACE_DETAILS = "/space/details/:id";
    static MY_SPACES = "/my_spaces";
    static SPACE_CREATE = "/space/create";
    static SPACE_EDIT = "/space/edit/:id";
    static SPACE_MANAGE = "/space/manage/:id";
    static SPACE_RESERVATIONS = "/my_spaces/reservations";
    static SPACE_CONTACT_INFO = "/space/contact/:id";
    static SPACE_BALANCES = "/my_spaces/balances";

    static ADVERTISEMENT_DETAILS = "/advertisement/details/:id";
    static CREATE_ADVERTISEMENT = "/advertisement/create";
    static EDIT_ADVERTISEMENT = "/advertisement/edit/:id";
    static MY_ADVERTISEMENTS = "/my_advertisements";
    static ADVERTISEMENT_RESERVATIONS = "/my_advertisements/reservations";
    static ADVERTISEMENT_CONTACT_INFO = "/advertisement/contact/:id";
    static ADVERTISEMENT_BILLING = "/my_advertisements/billing";

    static CHECKOUT = "/checkout/:id";
    static EDIT_PROFILE = "/edit_profile";
    
}

export default AppRoutes;